import { render, staticRenderFns } from "./BaseDictItemList.vue?vue&type=template&id=318c4eae&scoped=true"
import script from "./BaseDictItemList.vue?vue&type=script&lang=js"
export * from "./BaseDictItemList.vue?vue&type=script&lang=js"
import style0 from "./BaseDictItemList.vue?vue&type=style&index=0&id=318c4eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318c4eae",
  null
  
)

export default component.exports